/* eslint-disable max-classes-per-file, n/no-unsupported-features/node-builtins */
export class ShopifyApiError extends Error {
  public errors: unknown[] | undefined;

  public extensions: unknown;

  constructor(message: string, errors?: unknown[], extensions?: unknown) {
    super(message);
    this.name = 'ShopifyApiError';
    this.errors = errors;
    this.extensions = extensions;
  }
}

export class NetworkError extends Error {
  public statusCode: number | undefined;

  public response: Response | undefined;

  constructor(message: string, statusCode?: number, response?: Response) {
    super(message);
    this.name = 'NetworkError';
    this.statusCode = statusCode;
    this.response = response;
  }
}

export class ConfigurationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ConfigurationError';
  }
}
